import { Icon } from "@iconify/react";
import { useState } from "react";

const Dropdown = ({
  variant = "default",
  label,
  required = false,
  containerClassName,
  placeholder,
  className,
  direction = "down",
  value,
  onChange,
  options,
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const getVariantClassName = () => {
    let baseClassName =
      "px-5 py-2 rounded-[10px] overflow-hidden outline-none flex flex-row items-center justify-between gap-1 ";
    switch (variant) {
      case "default":
        baseClassName += "border border-[#27347726]  ";
        break;
      case "soft-blue":
        baseClassName += "border-[1.3px] border-[#A6B3F2] text-dark-blue ";
        break;
      case "primary-blur":
        baseClassName += "bg-[#F1F5FF] text-dark-blue ";
        break;
    }

    baseClassName += className ? ` ${className} ` : "";
    return baseClassName;
  };

  return (
    <div className={`flex flex-col gap-2 relative ${containerClassName ?? ""}`}>
      {direction === "up" && isOpen && (
        <ul className="absolute bottom-full left-0 w-full mt-2 bg-white rounded-[10px] shadow-[0_25px_50px_-12px_rgba(108,139,178,0.25)] border border-primary-blur-02 z-50 overflow-hidden">
          {options.map((option) => (
            <li
              key={option.value}
              onClick={() => {
                onChange(option);
                setIsOpen(false);
              }}
              className="px-5 py-2 hover:bg-primary-blur-01 transition-all duration-300 cursor-pointer text-sm"
            >
              {option.label}
            </li>
          ))}
        </ul>
      )}

      {label && (
        <label className="text-sm font-medium">
          {label} {required ? " *" : null}
        </label>
      )}
      <button
        className={`${getVariantClassName()} ${!value && "!text-dark-blue"}`}
        onClick={() => setIsOpen(!isOpen)}
      >
        <span>{value ? value : placeholder}</span>
        <Icon
          icon="mdi:chevron-down"
          className="w-4 h-4 transition-all duration-300"
          style={{
            transform: isOpen ? "rotate(180deg)" : "rotate(0deg)",
          }}
        />
      </button>

      {direction === "down" && isOpen && (
        <ul className="absolute top-full left-0 w-full mt-2 bg-white rounded-[10px] shadow-[0_25px_50px_-12px_rgba(108,139,178,0.25)] border border-primary-blur-02 z-50 overflow-hidden">
          {options.map((option) => (
            <li
              key={option.value}
              onClick={() => {
                onChange(option);
                setIsOpen(false);
              }}
              className="px-5 py-2 hover:bg-primary-blur-01 transition-all duration-300 cursor-pointer text-sm"
            >
              {option.label}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default Dropdown;
